import Service from "../../services";
import Swal from "sweetalert2";

const AuthModule = {
  namespaced: true,
  state: {
    userData: [],
    userDetail: {},
    isLoggedIn: false,
    accessToken: null,
    userLogin: {
      email: "",
      password: "",
    },
  },

  mutations: {
    SET_USER_DATA(state, data) {
      state.accessToken = data.access_token;
      state.userData = data;
    },
    SET_USER_LOGIN(state, data) {
      this.state.userLogin.email = data.email;
      this.state.userLogin.password = data.password;
    },
  },
  actions: {
    setLogin({ commit }, data) {
      commit("SET_USER_LOGIN", data);
    },
    onLogin({ commit }, data) {
      return Service.Auth.LogIn(data).then((res) => {
        console.log("res", res);
        if (res.code == "200" && res.result.access_token) {
          commit("SET_USER_DATA", res.result);
          return res;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
            text: "อีเมลชื่อผู้ใช้หรือพาสเวิร์ดไม่ถูกต้อง",
          });
        }
      });
    },
    onLoginGoogle({ commit }, data) {
      return Service.Auth.LogInGoogle(data)
        .then((res) => {
          if (res.code == "200" && res.result.access_token) {
            commit("SET_USER_DATA", res.result);
            return res;
          } else {
            return { code: 500, message: res.result.message };
          }
        })
        .catch((err) => {
          return { code: 500 };
        });
    },
    onLogOut({ commit }, data) {
      return Service.Auth.LogOut(data).then((res) => {
        if (res.code == "200") {
          commit("SET_USER_DATA", res.result);
          Swal.fire({
            title: "ออกจากระบบเรียบร้อย",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
          return res;
        }
      });
    },
    onLoginBypass({ commit }, data) {
      // return Service.Auth.LogInByPass(data).then(() => {
      let result = {
        code: 200,
        message: "success",
        result: {
          user: {
            id: 78,
            group_id: 5,
            username: "community",
            email: "community",
            first_name: "community",
            last_name: "testcommunity",
            avatar: null,
            active: null,
            login_attempt: 0,
            last_login: "2021-06-25T02:13:24.233232Z",
            created_at: "2021-06-23 03:45:49",
            updated_at: "2021-06-25 02:13:24",
            reminder: null,
            activation: null,
            last_activity: null,
            config: null,
            community_id: "1",
          },
          access_token:
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI1IiwianRpIjoiMmQ2OWQ1MzNjMjM2ZDg4NTc5ODhlZDE4ODE2MTYzMjMwMzZkMWRiZGU2OGZmM2FmZTA2NmE0NjljYjZlYzJjZmM2Y2E2OThhYmFlZDEzYmMiLCJpYXQiOjE2MjQ1ODcyMDQuNjE5ODQsIm5iZiI6MTYyNDU4NzIwNC42MTk4NDUsImV4cCI6MTY1NjEyMzIwNC41NjMxMzEsInN1YiI6Ijc4Iiwic2NvcGVzIjpbXX0.T76sdFdv6i2trY4MTzYegFbuzCBXHgbK3k2uHPNyu-LR7FhN0e8SEAeHKk3evcN_vASjFPa1yt3umTwswfBT55LDJ6Sh7l2wCLJzvql7zz3qgHRSRKkPVSsmUAg8c42UoMm0ZUiX0ru8I5sIczj-thaVijjA9lVrjgx99EdTuLN95V4EKqIf0S-4oc6pUNJaOXleVDkmgoTwv7fpzyXDjVZEmKApuj9WqkFtQ2FucoISvSSYAVEKuUpYGnGN-lOH-E0ienZXaDVGOqsA634LrNmyn2evhoiqWyweRdy6Oy-2FXr8MF-YLtmnm9NjsDVlJcjt1PZNW1_eo78hdVGGoThhyzavt6t4O5n-HXv1AKh5flqjITsIJW0NmhPe3hWBNrpkDUSDYKrArVDVoQih50J6u8FMG_G3twSv-J7XOLU-jrlJZrVLyoMJ2zutUSwSAdaSb8aulVLOUf1zf7pJrO0LUVM0os5mEubwxJwtofHkTVDM4CgYjXMUXe_RWrAKNx2yZg3hps_IeytmxnahsZ04k0VxLdA7AmAy9wWQqeFy6NhxMfYJqHr5nRnBUL1Lgp1_4N6Y5JyAn9gwb2AgSwZS1rVupL6-Z-f0-q3X_pif4qrDhcZN4H_zIuAwqs9VNOohfx9nn5GY57MptEnn77yAcmWmpFaK_DYUB3fGM8Y",
          token_type: "bearer",
        },
      };
      commit("SET_USER_DATA", result);
      return result;
      // });
    },

    onForgetPassword({ commit }, data) {
      return Service.Auth.forgetPassword(data)
        .then((res) => {
          if (res.result.message === "success") {
            return res;
          } else {
            return { code: 500, message: res.result.message };
          }
        })
        .catch((err) => {
          return { code: 500 };
        });
    },

    onResetPassword({ commit }, data) {
      return Service.Auth.resetPassword(data)
        .then((res) => {
          if (res.result.message === "success") {
            return res;
          } else {
            return { code: 500, message: res.result.message };
          }
        })
        .catch((err) => {
          return { code: 500 };
        });
    },
  },
};

export default AuthModule;
